import PillTooltipHost_vue_vue_type_script_setup_true_lang_default from "./PillTooltipHost.vue.script.js";
//#region src/v2/components/code-input/PillTooltipHost.vue
var PillTooltipHost_default = PillTooltipHost_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { PillTooltipHost_default as default };

//# sourceMappingURL=PillTooltipHost.vue.js.map